'use client';

import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { IconButton } from '../../../../../components/icon-button';
import { Tooltip } from '../../../../../components/tooltip';

export function ReasonHeaderAction({
  title,
  reason,
  icon,
  color,
}: {
  title: string;
  reason: string;
  icon: ReactNode;
  color: string;
}): ReactNode {
  const t = useTranslations(
    'designSystem.chat.guardrailConfirmationPromptCard',
  );

  return (
    <Tooltip title={title} subtitle={reason} maxW="360px" openDelay={150}>
      <IconButton
        variant="ghost"
        size="xs"
        aria-label={t('reason')}
        onClick={(event) => event.stopPropagation()}
        color={color}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
}
